export const EbgNotificationsTabsIds = {
  PENDING: 'pending',
  REVIEWED: 'reviewed',
  ARCHIVE: 'archive',
};
